module.exports = __webpack_public_path__ + "img/envelope-nikon-it.1219f914.png";